// Motor de tarifas OFFLINE (espejo del backend routers_operativa.py).
// Calcula el monto de estancia con el reloj local del dispositivo y la última tarifa conocida
// (snapshot cacheado). Debe coincidir con _calc_tarifa_v2 / _calc_monto del servidor.
//
// PURO (Fase 0 · dominio compartido Web/Native): solo usa Date; sin navegador, UI, React, API ni storage.
// Movido desde lib/offlineTarifa.js (que ahora re-exporta desde aquí). Comportamiento idéntico.

function round2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

// Espejo de _calc_tarifa_v2 (motor v2: bloque inicial + hora/fracción + tolerancia + tope diario).
function calcV2(t, minutos) {
  const tol = Number(t.tolerancia_minutos || 0);
  if (minutos <= tol) return 0;
  const precioBloque = Number(t.precio_bloque || 0);
  const precioHora = Number(t.precio_hora || 0);
  let total = precioBloque;
  const rem = minutos - Number(t.bloque_inicial_horas || 0) * 60 - tol;
  if (rem > 0) {
    const fullHoras = Math.floor(rem / 60);
    total += fullHoras * precioHora;
    const resto = rem - fullHoras * 60;
    if (resto > 0) {
      const minFrac = Number(t.minutos_fraccion || 0);
      const precioFrac = Number(t.precio_fraccion || 0);
      if (minFrac > 0 && precioFrac > 0) {
        total += Math.ceil(resto / minFrac) * precioFrac;
      } else if (t.cobro_estricto_redondeo) {
        total += precioHora;
      } else {
        total += precioHora * (resto / 60);
      }
    }
  }
  const max = Number(t.maximo_diario || 0);
  if (max > 0) total = Math.min(total, max);
  return round2(total);
}

// Espejo de _calc_monto (esquema legacy: Fijo / Por_Hora / Tiempo_Libre).
function calcLegacy(t, minutos) {
  const esq = t.esquema;
  if (esq === "Tiempo_Libre") return 0;
  const base = Number(t.monto_base || 0);
  if (esq === "Fijo") return base;
  if (minutos <= 60) return base;
  const extra = minutos - 60;
  const intervalo = Number(t.intervalo_fraccion || 0);
  const montoFrac = Number(t.monto_fraccion || 0);
  if (intervalo > 0 && montoFrac > 0) return round2(base + Math.ceil(extra / intervalo) * montoFrac);
  return round2(base * Math.ceil(minutos / 60));
}

function pickTarifa(snapshot, tipo) {
  if (!snapshot || !snapshot.tarifas) return null;
  if (tipo && snapshot.tarifas[tipo]) return snapshot.tarifas[tipo];
  const keys = Object.keys(snapshot.tarifas);
  return keys.length ? snapshot.tarifas[keys[0]] : null;
}

// Monto de estancia offline (aplica también el modelo de cobro de la sucursal).
export function calcMontoLocal(snapshot, tipo, minutos) {
  const t = pickTarifa(snapshot, tipo);
  if (!t) return 0;
  const monto = t.engine === "legacy" ? calcLegacy(t, minutos) : calcV2(t, minutos);
  const modelo = (snapshot.modelo_cobro || "COMBINADO").toUpperCase();
  if (modelo === "SOLO_VALET") return 0;
  return monto;
}

export function minutosLocal(fechaEntradaISO) {
  const entrada = new Date(fechaEntradaISO).getTime();
  const now = Date.now();
  return Math.max(0, Math.floor((now - entrada) / 60000));
}

export function estanciaTexto(minutos) {
  const h = Math.floor(minutos / 60);
  const m = minutos % 60;
  return h ? `${h}h ${m}m` : `${m}m`;
}
